$('body').on('click', '.add-owner-trigger', function() {
    openModal('.add-owner');
    return false;
});

$("body").on("click", ".open-owner-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".owner-menu-wrapper");

    $(".owner-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".owner-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".owner-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-owner-trigger', function() {
    var data = $(this).parents('.owner');
    var action = $('.edit-owner form').attr('data-action').replace('{owner}', data.attr('data-owner'));
    $('.edit-owner form').attr('action', action);

    $('.edit-owner [name="name"]').val(data.attr('data-name'));
    $('.edit-owner [name="hebrew_name"]').val(data.attr('data-hebrew_name'));
    $('.edit-owner [name="street"]').val(data.attr('data-street'));
    $('.edit-owner [name="apt"]').val(data.attr('data-apt'));
    $('.edit-owner [name="city"]').val(data.attr('data-city'));
    $('.edit-owner [name="state"]').val(data.attr('data-state'));
    $('.edit-owner [name="zip"]').val(data.attr('data-zip'));
    $('.edit-owner [name="email"]').val(data.attr('data-email'));
    $('.edit-owner [name="phone"]').val(data.attr('data-phone'));

    openModal('.edit-owner');
    closeDropdown();
    return false;
});

$('body').on('click', '.add-owner-coupon-trigger', function () {
    var data = $(this).parents('.owner');
    var action = $('.add-owner-coupon form').attr('data-action').replace('{owner}', data.attr('data-owner'));
    $('.add-owner-coupon form').attr('action', action);

    $('.add-owner-coupon [name="email"]').val(data.attr('data-email'));
    $('.add-owner-coupon [name="phone"]').val(data.attr('data-phone'));

    openModal('.add-owner-coupon');
    closeDropdown();
    return false;
});

$('body').on('submit', '.add-owner form, .edit-owner form, .add-owner-coupon form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-owner', function(data) {
    // console.log(data);
    var element;

    if($('.owner[data-owner="'+data.owner+'"]').length) {
        element = $('.owner[data-owner="'+data.owner+'"]');

		element.attr('data-name', data.name);
        element.attr('data-hebrew_name', data.hebrew_name);
        element.attr('data-street', data.street);
        element.attr('data-apt', data.apt);
        element.attr('data-city', data.city);
        element.attr('data-state', data.state);
        element.attr('data-zip', data.zip);
        element.attr('data-email', data.email);
        element.attr('data-phone', data.phone);

        element.find('[data-input="name"]').html(data.name);
        element.find('[data-input="hebrew_name"]').html(data.hebrew_name);
        element.find('[data-input="email"]').html(data.email);
        element.find('[data-input="phone"]').html(data.phone);
        element.find('[data-input="street"]').html(data.street);
        element.find('[data-input="apt"]').html(data.apt);
        element.find('[data-input="city"]').html(data.city);
        element.find('[data-input="state"]').html(data.state);
        element.find('[data-input="zip"]').html(data.zip);
        element.find('[data-input="total_seats"]').html(data.total_seats);
        element.find('[data-input="total_seat_cost_parsed"]').html(data.total_seat_cost_parsed);
        element.find('[data-input="total_payments"]').html(data.total_payments);
        element.find('[data-input="total_paid_parsed"]').html(data.total_paid_parsed);
        element.find('[data-input="total_upcoming_payments"]').html(data.total_upcoming_payments);
        element.find('[data-input="total_upcoming_paid_parsed"]').html(data.total_upcoming_paid_parsed);

        element.find('.owner-menu').html(buttons(data.buttons));
        return;
    }

    if($('body').attr('data-page') === '1') {
        element = $('<tr>', {
            class: 'owner',
            'data-owner': data.owner,
            'data-name': data.name,
            'data-hebrew_name': data.hebrew_name,
            'data-street': data.street,
            'data-apt': data.apt,
            'data-city': data.city,
            'data-state': data.state,
            'data-zip': data.zip,
            'data-email': data.email,
            'data-phone': data.phone
        });

        element.append(`<td>
            <p data-input="name">${data.name}</p>
            <p class="small-text" data-input="hebrew_name">${data.hebrew_name}</p>
        </td>

        <td>
            <p class="small-text" data-input="email">${data.email}</p>
            <p class="small-text" data-input="phone">${data.phone}</p>
        </td>

        <td>
            <p>
                <span data-input="street">${data.street}</span>
                <span data-input="apt">${data.apt}</span>
            </p>

            <p class="small-text">
                <span data-input="city">${data.city}</span>
                <span data-input="state">${data.state}</span>
                <span data-input="zip">${data.zip}</span>
            </p>
        </td>

        <td>
            (<span data-input="total_seats">${data.total_seats}</span>)
            <span data-input="total_seat_cost_parsed">${data.total_seat_cost_parsed}</span>
        </td>

        <td>
            (<span data-input="total_payments">${data.total_payments}</span>)
            <span data-input="total_paid_parsed">${data.total_paid_parsed}</span>
        </td>
        
        <td>
            (<span data-input="total_upcoming_payments">${data.total_upcoming_payments}</span>)
            <span data-input="total_upcoming_paid_parsed">${data.total_upcoming_paid_parsed}</span>
        </td>
        <td class="owner-menu-wrapper menu-wrapper" data-dropdown="owner-${data.owner}">
            <a href="" class="icon-more open-owner-menu open-menu"></a>
            <ul class="owner-menu menu">
                 ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.owners tbody').prepend(element);
    }
});